export default __webpack_public_path__ + "static/media/bell.a9140f4d.svg";